import AptUnitMiniMap from "./apt-unit-minimap"

const AptUnitPreviewCard = ({ dong, unitMap, palette, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="
      flex flex-col
      border border-gray-300 rounded-xl p-3 bg-white shadow-sm 
      hover:shadow-md hover:scale-102 hover:bg-gray-50 
      transition cursor-pointer"
    >
      <div className="flex items-center mb-3 gap-1">
        <h3 className="font-bold">{dong}동</h3>
        <p className="text-sm text-gray-500">({Object.keys(unitMap).length}세대)</p>
      </div>
      <div className="flex-1 flex items-center">
        <AptUnitMiniMap unitMap={unitMap} palette={palette} />
      </div>
    </button>
  )
}

export default AptUnitPreviewCard
